<template>
  <div>
    <app-cells position="between">
      <h1 class="title">Analytics</h1>
    </app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'EmployeesAnalyticsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'employees-analytics', label: 'Summary' },
        { name: 'employees-analytics-compensation', label: 'Compensation' },
      ],
    }
  },
}
</script>
